import React from "react";
import {
  Page,
  FormGroup,
  onMount,
  PendingButton,
  withPopover,
} from "components/common";
import { withXeroErrors } from "components";
import { Table, Row, Col, PopoverBody, Button } from "reactstrap";
import { Trans } from "react-i18next";
import Select from "react-select";
import { compose, withPropsOnChange, withState, withHandlers } from "recompose";
import currencyCodes from "./currencyCodes.json";
import { fromPairs, keyBy, reject } from "lodash";
import { withOrganisationContextConsumer } from "contexts/OrganisationContext";
import BackButton from "components/refactoring/BackButton";

export const Currencies = ({
  currencies,
  pending,
  onAddCurrency,
  keyedCurrencyCodes,
  Popover,
  currencyCodes,
  setSelectedCurrency,
  togglePopover,
  selectedCurrency,
  XeroErrors,
}) => (
  <Page title="Currencies" className="inv-table">
    <div className="flex flex-column mb-2">
      <BackButton />
    </div>
    <XeroErrors />
    <FormGroup label="Add Currency" className="mr-2">
      <Row noGutters>
        <Col>
          <Select style={{backgroundColor:'#F4F7FE'}}
            options={currencyCodes}
            labelKey="Name"
            valueKey="CurrencyCode"
            simpleValue
            onChange={setSelectedCurrency}
            value={selectedCurrency}
          />
        </Col>
        <Col xs="auto" className="ml-1">
          <Button
            color="primary"
            onClick={togglePopover}
            disabled={!selectedCurrency}
            id="add-button"
          >
            <Trans>Add</Trans>
          </Button>
          <Popover target="#add-button" placement="left">
            <PopoverBody>
              <div className="text-center">
                <Trans>
                  Are you sure you want to add this currency? This action cannot
                  be undone.
                </Trans>
              </div>
              <div className="d-flex justify-content-end mt-1">
                <PendingButton
                  size="sm"
                  color="success"
                  disabled={!selectedCurrency}
                  onClick={onAddCurrency}
                  pending={pending}
                >
                  Confirm
                </PendingButton>
              </div>
            </PopoverBody>
          </Popover>
        </Col>
      </Row>
    </FormGroup>

    <Table size="sm">
      <thead>
        <tr>
          <th>
            <Trans>Currency</Trans>
          </th>
        </tr>
      </thead>
      <tbody>
        {currencies.map((i) => (
          <tr key={i.Code}>
            <td dir="ltr">{keyedCurrencyCodes[i.Code] || i.Code}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Page>
);

export const enhance = compose(
  withOrganisationContextConsumer,
  onMount(
    ({ xero }) =>
      () =>
        Promise.props({
          currencies: xero.get("currencies").get("data"),
          keyedCurrencyCodes: fromPairs(
            currencyCodes.map((i) => [i.CurrencyCode, i.Name])
          ),
        })
  ),
  withXeroErrors(),
  withPopover(),
  withState("selectedCurrency", "setSelectedCurrency", null),
  withState("pending", "setPending", null),
  withPropsOnChange(["currencies"], ({ currencies }) => {
    const keyedCurrencies = keyBy(currencies, "Code");

    return {
      currencyCodes: reject(
        currencyCodes,
        (i) => keyedCurrencies[i.CurrencyCode]
      ),
    };
  }),
  withHandlers({
    onAddCurrency:
      ({
        xero,
        currencies,
        setSelectedCurrency,
        setXeroErrors,
        selectedCurrency,
        setState,
        setPending,
        clearContext,
      }) =>
      () => {
        const newCurrency = {
          Code: selectedCurrency,
        };

        setPending(true);

        xero
          .post("currencies", newCurrency)
          .then(() => {
            setSelectedCurrency(null);
            setState({
              currencies: [newCurrency, ...currencies],
            });
            clearContext("currencies");
          }, setXeroErrors)
          .finally(() => setPending(false));
      },
  })
);

export default enhance(Currencies);
